import React from 'react';

import {Modal, message, Tag} from 'antd';

import fetch from '../../fetch';
import utils from '../../../utils';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columnsArray = [
    { type: 'selection' },
    {   
        key:'$index', 
        label: '序号',
        width: 80
    },
    {key:'fileName', label: '文件名称'},
    {key:'filePath', label: '文件路径'},
    {key:'fileResponsiblePersonCode', label: '责任人工号', width: 120},
    {key:'fileResponsiblePersonName', label: '责任人名称', width: 120},
    {key:'placeOrgName', label: '发文部门'},
    {key:'fileStatus', label: '文件状态', width: 100,render:(d) => (+d === 2 ? <Tag color='#52c41a'>正式提交</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {key:'importStatus', label: '导入状态', width: 100,render:(d) => (+d === 2 ? <Tag color='#52c41a'>导入完成</Tag> : +d === 1 ? <Tag color='#1890ff'>未导入完成</Tag> : <Tag color='#1890ff'>无导入数据</Tag>)},
    {key:'realName', label: '上传人'},
    {key:'fileDesc', label: '文件描述'},
    {key:'lastUpdateTime', label: '上传时间'},
    {key:'termName', label: '归档学期/年度', width: 150},
    {type:'action', label: '操作', values: ['read','video','image', 'down', 'file']},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {key:'fileName', label: '文件名称'},
    {key:'filePath', label: '文件路径'},
    {key:'fileResponsiblePersonCode', label: '责任人工号', width: 120},
    {key:'fileResponsiblePersonName', label: '责任人名称', width: 120},
    {key:'placeOrgName', label: '发文部门'},
    {key:'fileStatus', label: '文件状态', width: 100,render:(d) => (+d === 2 ? <Tag color='#52c41a'>正式提交</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {key:'importStatus', label: '导入状态', width: 100,render:(d) => (+d === 2 ? <Tag color='#52c41a'>导入完成</Tag> : +d === 1 ? <Tag color='#1890ff'>未导入完成</Tag> : <Tag color='#1890ff'>无导入数据</Tag>)},
    {key:'realName', label: '上传人'},
    {key:'fileDesc', label: '文件描述'},
    {key:'lastUpdateTime', label: '上传时间'},
    {key:'termName', label: '归档学期/年度', width: 150},
    {type:'action', label: '操作', values: ['read','video','image', 'down', 'file']},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('dossier/file/manage/listAssign?' + params.join('&'), keywords)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = []
        if(extParams != null) {
            for(let i = 0; i < columnsArray.length; i++) {
                newArray.push(columnsArray[i])
                if(i === 1) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
        }
    })
    .then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                fileStatus: d.fileStatus,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const insert = (domain) => {
    return fetch.post('dossier/file/manage/insert' , domain)
    .then(response =>{
        return response
    })
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('dossier/file/manage/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const exist = (id) => {
    return fetch.post('dossier/file/manage/exist/'+ id)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        const data = getUserSelectData();
        if(data.fileStatus == 2){
            Modal.info({
                title: '请重新选择一项数据！',
                content: '该文件已正式提交，不能删除！',
            });
        }else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    remove(DataGrid.selections).then(response => {
                        if(response.code === 200) {
                            message.success(response.message);
                            DataGrid.selections = [];
                            DataGrid.refresh();
                        }
                    });
                },
                onCancel() {},
                okText:"确认",
                cancelText:"取消"
            });
        }
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.selectData.find(d => d.value === id)
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'file'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('dossier/file/manage/update/' + id, data);
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('dossier/file/delete', ids);
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('dossier/file/manage/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    const selections = DataGrid.selections;
    return fetch.post('dossier/file/manage/batch/submit', selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
        callback();
    });
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    const selections = DataGrid.selections;
    return fetch.post('dossier/file/manage/batch/back', selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

const exportFileDataByFolder = (id) => {
    return fetch.post(`dossier/file/manage/export/all/byFolderId`, {folderId: id})
}

export default {
    querySearch,
    querySearchById,
    batchSubmit,
    batchBack,
    insert,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    update,
    remove,
    getSelection: () => DataGrid.selections,
    getSelectionData,
    onSelectData,
    getUserSelectData,
    deleteFile,
    upload: `${fetch.base}dossier/file/upload`,
    exist,
    exportFileDataByFolder
}